<div class="profile-details-shell">
  <!-- Added by Amisha on 2026-07-23.
       Reason: keep the inline profile expansion open and show a centered loader
       while the contractor profile API is still resolving. -->
  <div
    class="profile-panel"
    [class.loading-profile]="isLoadingProfile"
  >
    <div
      class="profile-panel-loader"
      *ngIf="isLoadingProfile"
      aria-live="polite"
      aria-label="Loading contractor profile"
    >
      <mat-progress-spinner
        mode="indeterminate"
        diameter="50"
      ></mat-progress-spinner>
    </div>

    <ng-container *ngIf="!isLoadingProfile && contractor">
      <div class="profile-summary-card">
  <div class="profile-summary-wrapper">
    <div class="profile-avatar">
      <mat-icon>person</mat-icon>
    </div>

    <div class="profile-summary-grid">
      <div
        class="profile-summary-item"
        *ngFor="let item of profileSummary"
      >
        <span class="profile-summary-label">
          {{ item.label }}:
        </span>

        <span
          class="profile-summary-value"
          [title]="item.value"
        >
          {{ item.value }}
        </span>
      </div>
    </div>
  </div>
</div>

      <div class="profile-tabs">
        <button
          type="button"
          class="profile-tab-btn"
          *ngFor="let tab of tabs"
          [class.active]="activeTab === tab.id"
          [disabled]="isActiveTabLoading"
          (click)="setTab(tab.id)"
        >
          {{ tab.label }}
        </button>
      </div>

      <div
        class="profile-tab-card"
        [class.registrations-tab-card]="activeTab === 'registrations'"
      >
        <div
          class="tab-loading-overlay"
          *ngIf="isActiveTabLoading"
          aria-live="polite"
          aria-label="Loading tab data"
        >
          <app-loader></app-loader>
        </div>

        <div
          *ngIf="activeTab !== 'registrations'"
          class="profile-content-shell"
        >
        <div class="profile-tab-header">
          <h3
            class="profile-tab-title"
            *ngIf="activeTab !== 'registrations'"
          >
            {{
              activeTab === 'permits'
                ? 'Permits'
                : activeTab === 'profile'
                  ? 'Profile'
                  : 'Documents'
            }}
          </h3>

          <div class="profile-tab-header-actions">
            <button
              *ngIf="activeTab !== 'registrations'"
              type="button"
              class="header-icon-btn"
              aria-label="Close view profile"
              (click)="closeProfile()"
            >
              <mat-icon>keyboard_arrow_up</mat-icon>
            </button>
          </div>
        </div>

        <!-- Permits -->
       <div
  *ngIf="activeTab === 'permits'"
  class="detail-table-wrap"
>
  <wm-common-table
    *ngIf="
      !isLoadingPermits &&
      permitRows.length > 0
    "
    tableType="Staff"
    [columns]="permitColumns"
    [data]="permitRows"
    [serverSidePagination]="false"
    [fixedPagination]="false"
    [enableTableScroll]="true"
  >
  </wm-common-table>

  <div
    *ngIf="
      !isLoadingPermits &&
      permitRows.length === 0
    "
    class="permit-empty-state"
  >
    No permits are available for this contractor.
  </div>
</div>

        <!-- Profile -->
        <form
          *ngIf="activeTab === 'profile'"
          [formGroup]="profileForm"
          class="profile-form"
          (ngSubmit)="saveProfile()"
        >
          <div class="profile-form-section">
            <h4 class="profile-form-section-title">
              Business Information
            </h4>

            <div class="profile-form-grid single-column">
              <div
                class="profile-field"
                [class.invalid-field]="isFieldInvalid('businessName')"
              >
                <label class="profile-field-label">
                  Business Name
                  <span class="required-indicator">*</span>
                </label>

                <wm-common-textfield
                  formControlName="businessName"
                  [required]="true"
                >
                </wm-common-textfield>

                <wm-control-message
                  [control]="profileForm.get('businessName')"
                >
                </wm-control-message>
              </div>
            </div>
          </div>

          <div class="profile-form-section">
            <h4 class="profile-form-section-title">
              Contact Information
            </h4>

            <div class="profile-form-grid">
              <div
                class="profile-field"
                [class.invalid-field]="isFieldInvalid('contactFirstName')"
              >
                <label class="profile-field-label">
                  First Name
                </label>

                <wm-common-textfield
                  formControlName="contactFirstName"
                >
                </wm-common-textfield>

                <wm-control-message
                  [control]="profileForm.get('contactFirstName')"
                >
                </wm-control-message>
              </div>

              <div
                class="profile-field"
                [class.invalid-field]="isFieldInvalid('contactLastName')"
              >
                <label class="profile-field-label">
                  Last Name
                </label>

                <wm-common-textfield
                  formControlName="contactLastName"
                >
                </wm-common-textfield>

                <wm-control-message
                  [control]="profileForm.get('contactLastName')"
                >
                </wm-control-message>
              </div>

              <div
                class="profile-field"
                [class.invalid-field]="isFieldInvalid('emailAddress')"
              >
                <label class="profile-field-label">
                  Email Address
                </label>

                <wm-common-textfield
                  formControlName="emailAddress"
                >
                </wm-common-textfield>

                <wm-control-message
                  [control]="profileForm.get('emailAddress')"
                >
                </wm-control-message>
              </div>

              <div
                class="profile-field"
                [class.invalid-field]="isFieldInvalid('phoneNumber')"
              >
                <label class="profile-field-label">
                  Office Phone
                </label>

                <wm-common-textfield
                  formControlName="phoneNumber"
                >
                </wm-common-textfield>

                <wm-control-message
                  [control]="profileForm.get('phoneNumber')"
                >
                </wm-control-message>
              </div>

              <div
                class="profile-field"
                [class.invalid-field]="isFieldInvalid('cellNumber')"
              >
                <label class="profile-field-label">
                  Cell Phone
                </label>

                <wm-common-textfield
                  formControlName="cellNumber"
                >
                </wm-common-textfield>

                <wm-control-message
                  [control]="profileForm.get('cellNumber')"
                >
                </wm-control-message>
              </div>

              <div
                class="profile-field"
                [class.invalid-field]="isFieldInvalid('faxNumber')"
              >
                <label class="profile-field-label">
                  Fax Number
                </label>

                <wm-common-textfield
                  formControlName="faxNumber"
                >
                </wm-common-textfield>

                <wm-control-message
                  [control]="profileForm.get('faxNumber')"
                >
                </wm-control-message>
              </div>
            </div>
          </div>

          <div
            class="profile-form-section"
            *ngIf="contractor.customFields?.length"
          >
            <h4 class="profile-form-section-title">
              Additional Fields
            </h4>

            <wm-contractor-custom-field-list
              #customFields
              [customFields]="contractor.customFields"
              [form]="profileForm"
            >
            </wm-contractor-custom-field-list>
          </div>

          <div class="profile-form-section">
            <h4 class="profile-form-section-title">
              Address
            </h4>

            <wm-address-detail
              [address]="contractor.address"
              [showButtons]="false"
              [required]="false"
              [showName]="false"
            >
            </wm-address-detail>
          </div>

          <div class="profile-form-footer">
            <wm-common-button
              [data]="{
                text: isSavingProfile ? 'SAVING...' : 'SAVE',
                variant: 'raised',
                className: 'profile-primary-save-btn',
                type: 'button',
                disabled: isSavingProfile,
                onClick: onSaveButtonClick
              }"
            >
            </wm-common-button>
          </div>
        </form>


        <!-- Documents -->
        <div
          *ngIf="activeTab === 'documents'"
          class="detail-table-wrap"
        >
          <wm-contractor-document-list
            [documents]="contractor.documents || []"
            [documentCategories]="documentCategories"
            [parentId]="contractor.id"
            [showUploadPreview]="true"
            (added)="addNewDocuments($event)"
            (deleted)="deleteDocument($event)"
            (saved)="saveDocument($event)"
          >
          </wm-contractor-document-list>
        </div>
        </div>

        <!-- Registrations -->
        <div
          *ngIf="activeTab === 'registrations'"
          class="registrations-tab-content"
        >
          <div class="registrations-shell">
            <div class="registrations-toolbar-shell">
              <div class="registrations-title">
                Registrations
              </div>

              <app-common-filterbuilder-staff-janus
                class="registrations-attribute-filter"
                [attributeOptions]="registrationFilterCriteria"
                [hideAttributeButton]="false"
                [myWorkOptions]="[]"
                [useMuiLayout]="true"
                [showFilterBuilder]="true"
                [attributePopoverClass]="'contractors-attribute-popover'"
                [customTemplate]="registrationToolbarTemplate"
                [id]="exportComponentId"
                (attributeSelect)="onRegistrationAttribute($event)"
                (filterChanged)="onRegistrationFilterChanged($event)"
              >
              </app-common-filterbuilder-staff-janus>
            </div>

            <ng-template #registrationToolbarTemplate>
              <button
                type="button"
                class="new-registration-btn"
                (click)="openNewRegistrationOverlay()"
              >
                NEW REGISTRATION
              </button>

              <button
                type="button"
                class="registrations-collapse-btn"
                aria-label="Close view profile"
                (click)="closeProfile()"
              >
                <mat-icon>keyboard_arrow_up</mat-icon>
              </button>
            </ng-template>

            <div class="detail-table-wrap registrations-table-card">
              <wm-common-table
                #registrationTable
                tableType="Staff"
                [columns]="registrationColumns"
                [data]="registrationRows"
                [isLoading]="isLoadingRegistrations"
                [serverSidePagination]="true"
                [fixedPagination]="true"
                [enableTableScroll]="true"
                [currentPage]="registrationCurrentPage"
                [totalPages]="registrationTotalPages"
                [pageSize]="registrationPageSize"
                [sortField]="registrationSortField"
                [sortDescending]="registrationSortDescending"
                expansionMode="inline"
                expandOn="cell"
                [expandedComponent]="expandedComponent"
                [expandedComponentInputs]="expandedComponentInputs"
                (pageChange)="onRegistrationPageChange($event)"
                (rowsPerPageChange)="onRegistrationRowsPerPageChange($event)"
                (sortChanged)="onRegistrationSortChanged($event)"
              >
              </wm-common-table>
            </div>
          </div>
        </div>

      </div>

    </ng-container>

    <div
      *ngIf="!isLoadingProfile && !contractor"
      class="profile-empty-state"
    >
      Contractor profile details are not available.
    </div>
  </div>
</div>

<div
  class="new-registration-disabled-layer"
  *ngIf="isNewRegistrationOverlayOpen"
  (wheel)="onNewRegistrationOverlayWheel($event)"
></div>

<div
  class="new-registration-backdrop"
  *ngIf="isNewRegistrationOverlayOpen"
  (wheel)="onNewRegistrationOverlayWheel($event)"
>
  <div class="new-registration-modal">
    <div class="new-registration-modal-header">
      <h3>New Contractor Registration</h3>

      <button
        type="button"
        class="new-registration-modal-close"
        aria-label="Close new contractor registration"
        (click)="closeNewRegistrationOverlay()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="new-registration-modal-body">
      <h4>Registration Form</h4>

      <div class="new-registration-field">
        <label for="new-registration-client">
          Jurisdiction
        </label>

        <wm-common-dropdown
          id="new-registration-client"
          class="new-registration-dropdown"
          [data]="jurisdictionDropdownData"
          (valueChange)="onNewRegistrationClientChange($event)"
        >
        </wm-common-dropdown>

        <div
          class="new-registration-helper"
          *ngIf="isLoadingRegistrationClients"
        >
          Loading jurisdictions...
        </div>
      </div>

      <div class="new-registration-field">
        <label for="new-registration-type">
          Contractor Type
        </label>

        <wm-common-dropdown
          id="new-registration-type"
          class="new-registration-dropdown"
          [data]="contractorTypeDropdownData"
          (valueChange)="newRegistrationTypeId = $event"
        >
        </wm-common-dropdown>

        <div
          class="new-registration-helper"
          *ngIf="isLoadingRegistrationTypes"
        >
          Loading contractor types...
        </div>

        <div
          class="new-registration-helper"
          *ngIf="newRegistrationClientId && !isLoadingRegistrationTypes && newRegistrationTypes.length === 0"
        >
          Please renew your current registrations.
        </div>
      </div>
    </div>

    <div class="new-registration-modal-footer">
      <button
        type="button"
        class="new-registration-cancel"
        [disabled]="isStartingRegistration"
        (click)="closeNewRegistrationOverlay()"
      >
        CANCEL
      </button>

      <button
        type="button"
        class="new-registration-start"
        [disabled]="!newRegistrationClientId || !newRegistrationTypeId || isStartingRegistration"
        (click)="startNewRegistrationApplication()"
      >
        {{ isStartingRegistration ? 'STARTING...' : 'START' }}
      </button>
    </div>
  </div>
</div>

<wm-common-confirmation-modal
  [data]="modalData"
  (onYesClick)="confirmRegistrationAction()"
  (onNoClick)="cancelRegistrationAction()"
  (onOkClick)="closeRegistrationModal()"
  (onCloseClick)="closeRegistrationModal()"
  [isApplicantMobileview]="true"
>
</wm-common-confirmation-modal>
